import { OrganisationLite } from '@/business/organisation/interfaces/organisation-lite'
import { AttachedResource, ProjectPartner, ProjectResponseStateEnum } from '@/api/generated'
import { Resource } from '@/shared/interfaces/resource'
import { Post } from '@/business/post/models/post'
import { emptyPageResponse, PageResponse } from '@/shared/interfaces/page-response'
import { OfferLite } from '@/business/offers/models/offer-lite'

export interface ProjectViewModel {
  categories: string[]
  description?: string
  gallery: Resource[]
  id: number
  name: string
  offer?: OfferLite
  organisation: OrganisationLite
  partners: ProjectPartner[]
  posts: PageResponse<Post>
  resources: AttachedResource[]
  shortDescription?: string
  state: ProjectResponseStateEnum
  visible: boolean
}

export const EmptyProject: ProjectViewModel = {
  categories: [],
  gallery: [],
  id: -1,
  name: 'Empty',
  organisation: {
    categories: [],
    id: -1,
    name: 'Empty',
  },
  partners: [],
  posts: emptyPageResponse(),
  resources: [],
  shortDescription: 'empty',
  state: ProjectResponseStateEnum.INEDITMODE,
  visible: false,
}
